import { useEffect } from "react";
import Spinner from "../../../../../utils/Spinner";
import SmallAndSquareMaerskModel from "./SmallAndSquareMaerskModel";

const OrgModelOverview = (props) => {

  return (
    <>
      {props.maserskmodel?.maerskmodelLoading ? (
        <div className="justify-content-md-center">
          {" "}
          <Spinner
            text="Maersk model"
          />
        </div>
      ) : (
        <SmallAndSquareMaerskModel
          maserskmodel={props.maserskmodel}
          name="By Maersk Models"
          tag="orgModels"
        />
      )}
    </>
  );
};

export default OrgModelOverview;
